export default __webpack_public_path__ + "static/GoogleAds-0143b40ddc3503c3d689666fbf6d3daa.png";